module.exports = __webpack_public_path__ + "static/img/page3-img1.73d68db.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/page3-img1.jpg
// module id = h8WV
// module chunks = 0